import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { AppCard } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalConstructionEmergencyAspectsCard(
  props
) {
  const { description, values, showNullValue = false } = props;
  const [probability] = useState([
    <Translator file="module-comsaEnvironmental" name="none" />,
    <Translator file="module-comsaEnvironmental" name="low" />,
    <Translator file="module-comsaEnvironmental" name="medium" />,
    <Translator file="module-comsaEnvironmental" name="high" />,
  ]);
  const [gravity] = useState([
    <Translator file="module-comsaEnvironmental" name="none" />,
    <Translator file="module-comsaEnvironmental" name="low" />,
    <Translator file="module-comsaEnvironmental" name="moderate" />,
    <Translator file="module-comsaEnvironmental" name="remarkable" />,
  ]);
  const [valuationText] = useState([
    <Translator file="module-comsaEnvironmental" name="no.applicable" />,
    <Translator file="module-comsaEnvironmental" name="not-significant" />,
    <Translator file="module-comsaEnvironmental" name="significant" />,
  ]);

  const getProbability = useCallback(() => {
    if (showNullValue && values?.probability === 1) {
      return <Translator file="module-comsaEnvironmental" name="null" />;
    }

    return probability[values?.probability] || '';
  }, [probability, values, showNullValue]);

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            <Translator
              file="module-comsaEnvironmental"
              name="general.description-emergency-situation"
            />
            :
          </div>
          <div>
            <b>{description}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="probability" />:
          </div>
          <div>
            <b>{getProbability()}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="gravity" />:
          </div>
          <div>
            <b>{gravity[values?.gravity] || ''}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="evaluation" />:
          </div>
          <div
            className={
              values?.valuationText === 2
                ? 'text-danger'
                : values?.valuationText === 1
                ? 'text-warning'
                : 'text-success'
            }
          >
            <b>{valuationText[values?.valuationText] || ''}</b>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled(AppCard)`
  .info-block {
    display: flex;
    text-align: center;
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: ${colors.primaryLight};
    }
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
  }
`;
